export default {
  bidOrder: '/carrier/orders/bid',
  bookOrder: '/carrier/orders/book',

  bookOffer: '/carrier/offers/accept',
  bidOffer: '/carrier/offers/bid',

  getMapImage: '/carrier/trimble_maps/get_map',
  getTractorDetails: (movementNumber) => `/carrier/movements/locate_movement?movementNumber=${movementNumber}`
}
